// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__2mAiW","empty":"ModalGraph_empty__1Lk0X"};